import { rage } from '~/rage';
import { VehicleFuelType } from '~/shared';

import { playSound, Sound } from '~/assets/sounds';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setSelectedType } from '../../redux/slices/gasStationSlice';
import {
	StyledBackgroundNumber,
	StyledContainer,
	StyledFuelName,
	StyledFuelPrice,
	StyledInnerContainer,
} from './FuelTab.styled';

interface IFuelTabProps {
	type: VehicleFuelType;
}

const FuelTab = ({ type }: IFuelTabProps) => {
	const stationInfo = useLayoutSelector((state) => state.gasStation.info);
	const tabColors = useLayoutSelector((state) => state.gasStation.tabColors);
	const selectedType = useLayoutSelector(
		(state) => state.gasStation.selectedType,
	);
	const dispatch = useLayoutDispatch();

	const fuelName = rage.gasStation.getFuelTypeName(type);
	const fuelNumber = fuelName.replace(/[^0-9]+/g, '');
	const fuelPrice = stationInfo?.fuelTypes[type];

	const tabIndex = Object.keys(stationInfo?.fuelTypes || {}).indexOf(type);
	const tabColor = tabColors[tabIndex];

	return (
		<StyledContainer
			className={selectedType === type ? 'active' : ''}
			onClick={() => {
				playSound(Sound.ClickButton);
				dispatch(setSelectedType(type));
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledInnerContainer>
				<StyledFuelName $color={tabColor}>{fuelName}</StyledFuelName>
				<StyledFuelPrice>
					{fuelPrice}
					<span>&#160;</span>
					<span style={{ fontWeight: 400 }}>RUB</span>
				</StyledFuelPrice>
			</StyledInnerContainer>
			<StyledBackgroundNumber>{fuelNumber}</StyledBackgroundNumber>
		</StyledContainer>
	);
};

export { FuelTab };
